import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { BaseComponent } from 'src/app/_base/base.component';
import { SocialLearningService, FilesService } from 'src/app/_services';
import { FileUpload, FileUploadResult } from 'src/app/_models';
import { FileStatuses } from 'src/app/_enums/file-statuses.enum';
import { MimeTypes } from 'src/app/_enums';

@Component({
  selector: 'app-facebook-uploader',
  templateUrl: './facebook-uploader.component.html',
  styleUrls: ['./facebook-uploader.component.scss']
})
export class FacebookUploaderComponent extends BaseComponent implements OnInit {
  @ViewChild('Uploader')
  uploaderRef: ElementRef;
  @Input()
  isUploaderOpened: boolean = false;
  @Input()
  files: FileUpload[] = [];
  @Input()
  allowedFileTypes: string[] = [];
  @Output()
  filesEmitter: EventEmitter<FileUpload[]> = new EventEmitter<FileUpload[]>();
  uploader: FileUploader = new FileUploader(this.allowedFileTypes.length > 0 ? { allowedMimeType: this.allowedFileTypes } : {});
  fileStatuses = FileStatuses;
  constructor(private socialLearningService: SocialLearningService, private filesService: FilesService) {
    super();
  }

  ngOnInit() {}
  onFileSelected(): void {
    this.uploader.queue.map(item => {
      const indexInFile: number = this.files.length;
      this.files.push({
        id: this.files.length,
        file: item._file,
        status: FileStatuses.uploading,
        result: null,
        path: null,
        audioPath: null,
        videoPath: null
      });
      this.socialLearningService.UploadAttachment(item._file).subscribe(
        (data: FileUploadResult) => {
          this.files[indexInFile].result = data;
          this.files[indexInFile].status = FileStatuses.succeeded;
          this.filesEmitter.emit(this.files);
        },
        () => {
          this.files[indexInFile].status = FileStatuses.failed;
          this.filesEmitter.emit(this.files);
        }
      );
      this.getFileOrDisplayPath(item._file, indexInFile);
    });
    this.uploader.clearQueue();
  }
  getFileOrDisplayPath(_file: File, fileIndex: number): void {
    const fileChecker = this.filesService.fileMimeTypeChecker(_file.type);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(_file);
    fileReader.onload = (event: ProgressEvent) => {
      if (fileChecker.mimeType === MimeTypes.Image) this.files[fileIndex].path = event.target['result'];
      else this.files[fileIndex].path = fileChecker.iconUrl;
      this.filesEmitter.emit(this.files);
    };
  }
  openUploader(): void {
    this.uploaderRef.nativeElement.click();
  }
  removeFile(fileIndex: number): void {
    if (this.files[fileIndex].status === FileStatuses.failed) this.files.splice(fileIndex, 1);
    else if (this.files[fileIndex].status === FileStatuses.succeeded) {
      this.socialLearningService.RemoveAttachment(this.files[fileIndex].id);
      this.files.splice(fileIndex, 1);
    }
  }
}
